<template>
  <div class="exhi_live">
    <div class="title">
      <h3>{{$t('navbar.news')}}</h3>
      <button @click="addLive">{{$t('homepage.addnews')}}</button>
    </div>
    <el-row>
      <el-col :span="8">
        <!-- 状态: -->
        {{ $t('common.status') }}:
        <el-select
          v-model="auditFlag"
          :placeholder="$t('common.select')"
          @change="getnewList()"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="state">
      <p><span>*</span>{{ $t('common.sort') }}</p>
      <p>
        <span>{{ $t('common.statusall') }} {{ auditInfo.entire }}</span>
        <span>{{ $tc('common.auditstatus2',0) }} {{ auditInfo.underReview }}</span>
        <span>{{ $tc('common.auditstatus2',1) }} {{ auditInfo.audited }}</span>
        <span>{{ $tc('common.auditstatus2',2) }} {{ auditInfo.auditNotPassed }}</span>
      </p>
    </div>
    <div class="box">
      <table>
        <thead>
          <tr>
            <th style="width: 123px">{{ $t('common.Number') }}</th>
            <th>{{ $t('news.coverPhoto') }}</th>
            <th style="width: 350px">{{ $t('news.newsTitle') }}</th>
            <th style="width: 350px">{{ $t('news.abstract') }}</th>
            <th>{{ $t('news.issueDate') }}</th>
            <th>{{ $t('common.status') }}</th>
            <th>{{ $t('common.operate') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in tableData" :key="index">
            <td><input type="text" class="inut" v-model="item.sort" @blur="inputblur(item.id, item.sort)" /></td>
            <td><img :src="item.coverPhoto" alt="" /></td>
            <td>{{ item.newsTitle }}</td>
            <td>{{ item.abstracts }}</td>
            <td>{{ item.createDate }}</td>
            <td>{{item.auditFlag}}</td>

            <td>
              <div style="cursor: pointer">
                <span @click="rowEdit(item.id)"
                  ><i class="el-icon-edit-outline">{{ $t('common.edit') }}</i></span
                >
                <span v-if="item.auditFlag == '已保存未申请提交审核'" @click="open(item.id)"
                  ><i class="el-icon-upload2">{{ $t('common.submit') }}</i></span
                >
                <span @click="del(item.id)"><i class="el-icon-delete">{{ $t('common.delete') }}</i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="item">
        <!--分页 -->
        <div class="pagination">
          <!-- <span>共{{ count }}条</span> -->
           <span>{{ $t('common.pagination',{ totalNum: count }) }}</span>
          <el-pagination
            class="explore_right_pages"
            layout="prev, pager, next"
            :current-page="currentPage4"
            @current-change="handleCurrentChange"
            :page-size="10"
            :total="count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatus,order,getnewsList,delet,LlistSave} from "../../../../api/newCenter";
import { forMat } from '../../../../utils/common.js';
export default {
  inject:['reload'],
  data() {
    return {
      baseUrl: forMat(),
      options: [
        {
          value: "",
          label: this.$t('common.statusall'),
        },
        {
          value: 0,
          label:this.$tc('common.auditstatus2',0),
        },
        {
          value: -1,
          label: this.$tc('common.auditstatus',1),
        },
        {
          value: 2,
          label: this.$tc('common.auditstatus',0),
        },
        {
          value: -2,
          label: this.$t('common.saveAudit'),
        },
      ],
      tableData: [],
      currentPage4: 1,
      //审核状态切换
      auditFlag: "",
      pageNum: "1",
      // 审核状态显示
      auditInfo: {},
      count:0,
    };
  },

  components: {},

  computed: {},
  mounted(){
    this.getnewList("1");
  },

  created() {
    this.getnewList("1");
  },

  methods: {
    addLive() {
      this.$router.push("/backIndex/add_news");
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getnewList(this.pageNum);
    },
    //获取新闻列表
    async getnewList(val) {
      let list = {};
      list.auditFlag = String(this.auditFlag);
      list.pageNo = val;
      list.pageSize = "10";
      let { data,headers } = await getnewsList(list);
      if (!data.data.hasOwnProperty("list")) {
        this.tableData = [];
        return false;
      }
      data.data.list.forEach((item) => {
        // item.coverPhoto = this.baseUrl+item.coverPhoto;
        if(item.coverPhoto.indexOf("http")  == -1){
            item.coverPhoto= this.baseUrl + item.coverPhoto;
        }

        item.coverPhoto = item.coverPhoto;
        item.auditFlag == 0 ? (item.auditFlag = "审核通过") : "";
        item.auditFlag == -1 ? (item.auditFlag = "未通过") : "";
        item.auditFlag == 2 ? (item.auditFlag = "审核中") : "";
        item.auditFlag == -2 ? (item.auditFlag = "已保存未申请提交审核") : "";
        item.videoType == 1 ? (item.videoType = "上传视频") : "";
        item.videoType == 2 ? (item.videoType = "直播外链") : "";
        item.videoType == 3 ? (item.videoType = "直播入口二维码") : "";
      });
      this.tableData = data.data.list;
      this.count = data.data.count
      this.getStatu();
    },
    // 审核状态统计
    async getStatu() {
      let data = await getStatus();
      this.auditInfo = data.data.data;
    },
    //点击编辑跳转，并且携带路由参数
    rowEdit(id) {
    	this.$router.push({ name: 'exhiNews',query:{id}});
    },
    // 排序
    async inputblur(id,sort){
      const params = {id,sort}
      try {
        const { data } = await order(params);
        if (data.code === 200) {
          this.getnewList();
          this.$message({
            type: 'success',
            message: this.$t('dialog.suncSort'),
          });
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    // 删除数据
    del(id) {
      this.$confirm(this.$t('dialog.confirmDelete'), this.$t('dialog.attention'), {
        confirmButtonText: this.$t('dialog.sure'),
        cancelButtonText: this.$t('dialog.cancel'),
        customClass: 'diologClass',
      }).then(() => {
          try {
            const params={id}
            delet(params)
            this.getnewList();
            this.$message({
              type: 'success',
              message: this.$t('dialog.deletSucce'),
            });
            this.getnewList();
          } catch (e) {
            this.message.getStatus();
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('dialog.cancelDelet'),
          });
        });
    },
    //列表页面的提交按钮
    open(id){
      this.$confirm( this.$t('dialog.confirmSubmit'),'测试',{
          confirmButtonText: this.$t('dialog.sure'),
        cancelButtonText: this.$t('dialog.cancel'),
        customClass: 'diologClass',
      }).then(()=>{
        try{
         this.updataStatus(id)
         this.reload("/backIndex/exhi_news")
        }catch(e){
           this.message.getStatus();
        }
      })


    },
    // 更新状态
    async updataStatus(id){
      const params={id}
     const {data}=await LlistSave(params);
      if (data.code==200) {
       this.$message({
            type: 'success',
            message: this.$t('dialog.submitSuccess'),
          });
       this.getnewList(this.pageNum);
      }
    }
  },
};
</script>
<style lang='scss' scoped>
.exhi_live {
  box-sizing: border-box;
  padding: 18px 26px 26px 0;
  background: white;
  min-height: calc(100vh - 74px - 40px);


  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 17px;
    padding-left: 26px;
    h3 {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
    button {
      width: 77px;
      height: 28px;
      background: #006fb8;
      color: white;
      border-radius: 2px;
      border: none;
    }
  }
  .el-row {
    padding-left: 26px;
  }
  .state {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    font-size: 12px;
    // padding-left: 26px;
    p:first-child {
      color: red;
    }
    span {
      margin-left: 26px;
    }
  }
  .box {
    height: auto;
    position: relative;
    table {
      margin: 15px 0px 0px 28px;
      border-collapse: collapse;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      border-radius: 3px 3px 0px 0px;
      width: 98%;
      overflow: hidden;
      thead {
        //width: 100%;
        background: #006fb8;
        border-radius: 4px 4px 0px 0px;
        tr {
          height: 36px;
          color: rgba(255, 255, 255, 0.85);
          width: 100%;
          th {
            box-sizing: border-box;
            height: 36px;
            width: 200px;
            color: white;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
          }
        }
      }
      tbody {
        tr {
          height: 106px;
          border-bottom: 1px solid #e8e8e8;
          td {
            text-align: center;
            height: 106px;
            img {
              width: 104px;
              height: 78px;
              margin: 10px 0px;
            }
            span {
              color: #006fb8;
              margin: 0px 5px;
            }
            .inut {
              display: block;
              width: 35px;
              height: 24px;
              border: 1px solid #e0e0e0;
              line-height: 24px;
              color: #666666;
              margin-left: 25px;
              text-align: center;
            }
          }
          &:nth-child(even) {
            background-color: #f6f6f7;
          }
        }
      }

      .leaseCount {
        width: 100px;
        div {
          margin: 0 auto;
          text-align: center;
          width: 92px;
        }
      }
    }
    .pagination {
      // border: 1px solid red;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 30px;
      padding-right: 0;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-top: 6px;
        color: #666666;
      }
    }
  }
}
</style>
<style lang='scss' scoped >
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
</style>
<style lang="scss">
.diologClass {
  border: none;
  .el-message-box__header {
    background: #006fb8 !important;
    color: white;
  }
  .el-message-box__title{
    color: #fff;
    font-size: 18px;
  }
  .el-button--primary {
    background: #006fb8 !important;
  }
}
</style>
